import { COLORS, DOWNTILT_PREVIEW_DIMENSIONS } from 'helpers/globals'

const button = {
  color: 'white',
  background: COLORS.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0.5rem',
  '&:hover:not(.disabled)': {
    cursor: 'pointer',
    background: COLORS.primaryHover
  }
}

export default {
  container: {
    position: 'relative',
    maxHeight: 'calc(80vh - 70px)',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column'
  },
  warning: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: COLORS.warning,
    fontSize: '1.4rem'
  },
  canvasContainer: {
    flex: '1 1 400px',
    alignSelf: 'center',
    height: '100%',
    minHeight: 0,
    aspectRatio: '1.1',
    position: 'relative',
    '& canvas': { width: '100%', height: '100%' }
  },
  cameraIcon: {
    width: DOWNTILT_PREVIEW_DIMENSIONS.cameraIconHeight,
    height: 'auto',
    position: 'absolute',
    left: -21,
    top: 'calc(50% - 15px)',
    transform: 'rotateZ(90deg)'
  },
  sliderContainer: {
    display: 'flex',
    marginTop: '.5rem',
    touchAction: 'none',
    fontWeight: 500,
    position: 'relative',
    borderBottom: '1px solid #555'
  },
  inputContainer: {
    display: 'block',
    minWidth: '10%',
    position: 'relative',
    transition: 'flex-basis 200ms linear'
  },
  zones: {
    height: '100px',
    textAlign: 'center',
    color: 'white',
    position: 'relative',
    transition: 'background 200ms ease-in-out'
  },
  ppfInputBox: {
    background: '#c3c3c3',
    position: 'absolute',
    fontSize: '1.4rem',
    width: 80,
    height: 30,
    right: -40,
    bottom: 20,
    zIndex: 1
  },
  ppfInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${COLORS.secondary}`,
    transition: 'border 200ms linear, box-shadow 200ms linear',
    position: 'relative',
    zIndex: 1,
    '& input[type=number]': {
      background: 'white',
      width: '50%',
      height: '100%',
      border: 'none',
      borderRight: `1px solid ${COLORS.secondary}`,
      transition: 'border 200ms linear, background 200ms linear',
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&:disabled': {
        cursor: 'not-allowed',
        background: '#dddddd'
      }
    },
    '& span': {
      fontWeight: 400,
      width: '50%'
    },
    '&.invalid': {
      border: `1px solid ${COLORS.danger}`,
      boxShadow: `0 0 5px 0 ${COLORS.danger}`,
      '& input[type=number]': { borderRight: `1px solid ${COLORS.danger}` }
    }
  },
  arrowDown: {
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '20px solid #c3c3c3',
    position: 'relative',
    left: 30
  },
  superlativeWrapper: {
    display: 'flex',
    marginTop: '1rem',
    fontSize: '1.4rem',
    fontWeight: 500,
    '& span:first-of-type': { flex: 1 }
  },
  colorRow: {
    marginTop: '-1.5rem',
    display: 'flex',
    alignItems: 'center'
  },
  colorWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '50%',
    padding: '.5rem 1rem',
    transition: 'filter 200ms ease-in-out'
  },
  colorPicker: {
    padding: '.4rem',
    borderRadius: 2,
    cursor: 'default',
    width: 78,
    minWidth: 78,
    height: 86,
    border: '1px solid #bfbfbf',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      color: 'white',
      fontWeight: 500,
      display: 'block',
      marginBottom: '.4rem',
      textAlign: 'center',
      transition: 'background 200ms ease-in-out'
    }
  },
  colorsContainer: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  color: {
    height: 20,
    width: 20,
    display: 'flex',
    border: '1px solid #6c6c6c',
    borderRadius: '50%',
    '&:not(:nth-of-type(3n+0))': { marginRight: '.4rem' },
    '&:not(.disabled)': {
      cursor: 'pointer',
      '&:hover': { boxShadow: `0 0 3px 1px ${COLORS.secondary}` }
    }
  },
  checkIcon: {
    margin: 'auto',
    fontSize: '1.2rem',
    color: 'white'
  },
  ruler: {
    position: 'absolute',
    height: '20px',
    bottom: '-10px',
    width: '100%',
    zIndex: 2
  },
  mark: {
    position: 'absolute',
    borderLeft: '1px solid #555',
    height: '100%',
    width: '10%',
    '&:last-of-type': {
      borderRight: '1px solid #555'
    }
  },
  errorText: {
    color: 'red',
    height: '2.5rem',
    margin: '1rem',
    flex: '1 1 auto'
  },
  errorTextFadeIn: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s linear 0s, opacity 200ms linear'
  },
  errorTextFadeOut: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s linear 200ms, opacity 200ms linear'
  },
  errorIcon: {
    marginRight: '.5rem',
    fontSize: '2.5rem'
  },
  saveButton: {
    ...button,
    margin: '0.5rem',
    width: '20%',
    transition: 'opacity 200ms linear',
    '&.disabled': {
      opacity: '0.5',
      cursor: 'not-allowed'
    }
  },
  defaultButton: {
    ...button,
    background: COLORS.secondary,
    padding: '0 1.5rem',
    '&:hover:not(.disabled)': {
      background: '#535F69',
      cursor: 'pointer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AnalyticZonesSelector/style.js